import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Route } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../../_services/api.service';
import { AnpiService } from '../../../_services/anpi-code.service';
import { first } from 'rxjs/operators';
import { NgxUiLoaderService, Loader, SPINNER, POSITION, PB_DIRECTION } from 'ngx-ui-loader';
import { MatSnackBar } from '@angular/material/snack-bar';
declare var $: any;
import AOS from 'aos';
import 'aos/dist/aos.css';
import { Chart } from 'chart.js';
import 'chartjs-plugin-labels';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  employer: any;
  currentLang: any;
  isSubmitted = false;
  public languageForm: FormGroup;
  response: any;
  id: any;
  accountDetails: any;
  currentUser: any;
  login: any;
  employeeDetails: any;
  currentDetails: any;
  previousDetails: any;
  companyDetails: any;
  contribution: any;
  ctx: any;
  canvas: any;

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private api: ApiService,
              private route: ActivatedRoute,
              private ngxUiLoaderService: NgxUiLoaderService,
              private snackBar: MatSnackBar,
              private anpiService: AnpiService) {
      
    const data = localStorage.getItem('currentUserDetails');
    if (data) {
      this.accountDetails = JSON.parse(data);
      this.login = this.accountDetails.current_user;
      console.log("36 login value:", this.login)
      if (this.login == "1") {
        this.employer = true;
        console.log("36", this.employer)
      } else {
        this.employer = false;
        console.log("40", this.employer)
      }
    }

    if (this.router.getCurrentNavigation().extras.state) {
      console.log("54", this.router.getCurrentNavigation().extras.state)
      const data = this.router.getCurrentNavigation().extras.state.show_modal
      console.log(this.router.getCurrentNavigation().extras.state.show_modal)
      console.log(data)
      if (data == 1) {
        setTimeout(() => {
          console.log("60")
          $('#successModal').modal('show');
        }, 500);
      } else if (data == 2) {
        console.log("64")
        setTimeout(() => {
          $('#successModalCnssForm').modal('show');
        }, 500);
      }
      else if (data == 3) {
        console.log("64")
        setTimeout(() => {
          $('#successModalCnamgsForm').modal('show');
        }, 500);
      }

    }
  }

  ngOnInit() {
    //$('#successModal').modal('show')
 
    if (!this.api.getValidationStatus()) {}

    // AOS.init({
    //   disable: function() {
    //     var maxWidth = 600;
    //     return window.innerWidth < maxWidth;
    //   }
    // });
    this.anpiService.accountEvent.subscribe(() => {
      console.log("accounts api called")
      this.getAccountData();
    });
    this.getAccountData();
    setTimeout(() => {
      this.getChartData();
    }, 4500)

    
  }


  getChartData() {
    if (this.contribution) {
      this.canvas = document.getElementById('balancesheet1');
      this.ctx = this.canvas.getContext('2d');
      let profitLossChart = new Chart(this.ctx, {
        type: 'pie',
        data: {
          //labels: [this.incometxt + ' ' + totalincome + ' FCFA', this.expensetxt + ' ' + totalexpense + ' FCFA'],
          datasets: [{
            data: [this.contribution.worker, this.contribution.employer],
            backgroundColor: [
              "#5d5d5d",
              "#6A8FC2"
            ],
            borderWidth: 1
          }]
        },
        options: {
          responsive: false,
          maintainAspectRatio: false,
          plugins: {
            labels: {
              render: function(args: any) {
                // args will be something like:
                // { label: 'Label', value: 123, percentage: 50, index: 0, dataset: {...} }
                //return args.value + ' ' + "FCFA";
                //return args.label.split(":")[1];
                return;

                // return object if it is image
                // return { src: 'image.png', width: 16, height: 16 };
              },
              fontColor: '#000',
              overlap: true,
              shadowOffsetY: 5
            }
          },
          tooltips: {
            callbacks: {
              label: function(tooltipItem: any, data: any) {
                console.log(tooltipItem)
                console.log(data)
                var label = data.datasets[0].data[tooltipItem.index] || '';
                if (label) {
                  label += '';
                }
                return label;
              }
            }
          }
        }
      });
    }

  }




  getAccountData() {
    console.log("442 get employer details")
    this.ngxUiLoaderService.start();
    this.api.getAccountDetails().pipe(first())
      .subscribe(res => {
          this.ngxUiLoaderService.stop();
          this.response = res.results;
          if (res.status == 200) {
            console.log("88", res)
            this.accountDetails = this.response;
            if (this.response.current_user == 1) {
              this.currentUser = this.response.current_user;
              console.log("450", this.currentUser)
            } else if (this.response.employee.current_user == 2) {
              this.currentUser = this.response.employee.current_user;
              console.log("107", this.currentUser)
              this.employeeDetails = this.response.employee;
              this.companyDetails = this.response.company_details;
              this.contribution = this.response.contribution_rate;
              console.log("110", this.employeeDetails)
              console.log("111", this.currentDetails)
              console.log("114", this.contribution)
            }
            this.login = this.currentUser;
            console.log("92", this.login)
            if (this.login == "1") {
              this.employer = true;
            } else {
              this.employer = false;
            }
            if (this.currentUser == 1) {
              // this.accountDetails['BankDetails'] = 1;
              const data = JSON.stringify(this.accountDetails);
              localStorage.setItem('currentUserDetails', data);
            } else if (this.currentUser == 2) {
              const data = JSON.stringify(this.accountDetails.employee);
              localStorage.setItem('currentUserDetails', data);
              console.log("117", data)
            }
            this.anpiService.emitEvent();
          } else {
            console.log("no result")
            this.snackBar.open(res.message, "OK", {
              duration: 5000,
            });
          }
        },
        error => {
          console.log("errorrrrrrrrr")
          this.ngxUiLoaderService.stop();
        });
    console.log("no result")
  }
  closeModal() {
    $('#successModalCnssForm').modal('hide');
  }

}
